<template>
  <div>
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content" style="filter: blur(0px);">
        <div class="container-fluid">
          <h3 class="text-dark mb-1">Blank Page</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'Home'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue